<template>
  <div id="app">
    <header>
      <Navigation />
    </header>
    <b-container>
      <div class="mt-5">
        <alert />
        <div class="mt3">
          <router-view />
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import Navigation from "./components/Navigation.vue";
import Alert from "./components/Alert.vue";

import { Auth } from "aws-amplify";
import { Hub } from "aws-amplify";

export default {
  name: "App",
  components: {
    Navigation,
    Alert
  },
  data: function() {
    return {
      test: 4
    };
  },
  methods: {
    setCurrentUser: function(user, signedIn) {
      console.log(user);
      this.$store.commit("setSignedIn", signedIn);
      this.$store.commit("setCurrentUser", user);
    },
    onAuthEvent(payload) {
      console.log("onAuthEvent:", payload);
      if (payload.event == "cognitoHostedUI") {
        Auth.currentAuthenticatedUser({
          bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        })
          .then(user => {
            this.setCurrentUser(user, true);
            this.$router.push({
              name: "home"
              // params: { lang: this.$root.$i18n.locale }
            });
          })
          .catch(err => {
            console.log("currentAuthenticatedUser:", err);
          });
      }
      if (payload.event == "signIn") {
        Auth.currentAuthenticatedUser({
          bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        })
          .then(user => {
            this.setCurrentUser(user, true);
            this.$router.push({
              name: "home"
              // params: { lang: this.$root.$i18n.locale }
            });
          })
          .catch(err => {
            console.log("currentAuthenticatedUser:", err);
          });
      }
      if (payload.event == "signUp") {
        this.$store.commit("setSignedUp", true);
      }
      if (payload.event == "signUp_failure") {
        // @todo: Implement showing alert
      }
      if (payload.event == "signOut") {
        this.setCurrentUser(false, false);
        this.$router.push({
          name: "login"
          // params: { lang: this.$root.$i18n.locale }
        });
      }
      if (payload.event == "forgotPasswordSubmit") {
        if ({}.hasOwnProperty.call(payload.data, "username")) {
          const username = payload.data.username;
          this.$router.push({
            name: "login",
            query: { email: username }
          });
          this.$store.commit("setAlert", {
            variant: "success",
            message: payload.message
          });
        }
      }
    }
  },
  created() {
    document.title = this.$i18n.t("app.name");
    Auth.currentAuthenticatedUser({
      bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    })
      .then(user => {
        this.setCurrentUser(user, true);
      })
      .catch(err => {
        console.log("currentAuthenticatedUser:", err);
      });
    Hub.listen("auth", data => {
      const { payload } = data;
      this.onAuthEvent(payload);
      console.log(
        "A new auth event has happened: ",
        data.payload.data.username + " has " + data.payload.event
      );
    });
  }
};
</script>


<style>
/* This font is imported on Website, but it seems that its not in use.. So we do not need it for now.. */
/* @import url("https://fonts.googleapis.com/css?family=Raleway:200,400,700,600"); */
</style>

